import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SectionCard from "../../components/SectionCard";
import SectionRow from "../../components/SectionRow";
import { useAccess } from "../../hooks/useAccess";
import { currencyFormatter } from "utils/helpers/currencyFormatter";
import { getPrimaryActiveResource } from "utils/helpers/user";
import { renderPaymentType } from "utils/helpers/job";

function Compensation({ user, isSelf = false }: any) {
    const { t } = useTranslation();
    const canViewRates = useAccess(isSelf ? "canViewMyRates" : "canViewRates");

    const userJob = useMemo(
        () => getPrimaryActiveResource(user?.jobs || []) as any,
        [user],
    );

    const formatCurrency = (amount?: number) =>
        amount != null
            ? currencyFormatter(amount, 2, userJob?.currency)
            : undefined;

    if (!canViewRates) return null;

    return (
        <SectionCard title={t("compensation")}>
            <SectionRow
                label={t("hourly-or-salary")}
                value={userJob?.hourlyOrSalaried ? t(renderPaymentType(userJob.hourlyOrSalaried)) : undefined}
            />
            <SectionRow
                label={t("pay-currency")}
                value={userJob?.currency ? t(userJob.currency) : undefined}
            />
            {userJob?.hourlyOrSalaried === "H" ? (
                <>
                    <SectionRow
                        label={t("rate-of-pay")}
                        value={formatCurrency(userJob?.hourlyRate)}
                    />
                    <SectionRow
                        label={t("other-rate1")}
                        value={formatCurrency(userJob?.otherRate1)}
                    />
                    <SectionRow
                        label={t("other-rate2")}
                        value={formatCurrency(userJob?.otherRate2)}
                    />
                    <SectionRow
                        label={t("other-rate3")}
                        value={formatCurrency(userJob?.otherRate3)}
                    />
                    <SectionRow
                        label={t("other-rate4")}
                        value={formatCurrency(userJob?.otherRate4)}
                    />
                </>
            ) : (
                <SectionRow
                    label={t("salary")}
                    value={formatCurrency(userJob?.salary)}
                />
            )}
        </SectionCard>
    );
}

export default Compensation;
